import { useState } from "react";
import { Upload, Loader2, Music } from "lucide-react";
import ScaleChanger from "../components/ScaleChanger";
import API_BASE_URL from "../config";

export default function ScaleFinder() {

    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);

    const handleAnalyze = async () => {

        if (!file) {
            alert("Please select an audio file first.");
            return;
        }

        setLoading(true);
        setResult(null);

        const formData = new FormData();
        formData.append("file", file);

        try {

            const response = await fetch(
                `${API_BASE_URL}/api/analyze`,
                {
                    method: "POST",
                    body: formData,
                }
            );

            if (!response.ok) {
                throw new Error("Backend returned an error.");
            }

            const data = await response.json();

            console.log(data);

            setResult(data);

        } catch (error) {

            console.error(error);

            alert("Unable to analyze audio. Please make sure the backend is running.");

        } finally {

            setLoading(false);

        }

    };

    return (

        <div className="max-w-5xl mx-auto py-12">

            <div className="mb-10">

                <div className="text-xs uppercase tracking-[0.25em] text-muted-foreground mb-3">
                    Tool · 05
                </div>

                <h1 className="text-5xl font-bold">
                    Scale Studio
                </h1>

                <p className="text-muted-foreground mt-4">
                    Upload any song and instantly detect its scale, tempo and confidence.
                </p>

            </div>

            <div className="rounded-2xl border border-border bg-card p-10">

                <label
                    htmlFor="audioFile"
                    className="cursor-pointer flex flex-col items-center justify-center border-2 border-dashed rounded-xl p-16 hover:border-primary transition"
                >

                    <Upload
                        size={55}
                        className="text-primary mb-6"
                    />

                    <h2 className="text-2xl font-bold">
                        Drop Audio Here
                    </h2>

                    <p className="text-muted-foreground mt-2">
                        MP3 • WAV • M4A • FLAC
                    </p>

                    {file && (

                        <div className="mt-6 flex items-center gap-2 text-primary font-semibold">

                            <Music size={18} />

                            {file.name}

                        </div>

                    )}

                </label>

				<input
					id="audioFile"
					type="file"
					className="hidden"
					onChange={(e) => {
						if (e.target.files?.length) {
							setFile(e.target.files[0]);
						}
					}}
				/>

                <div className="mt-8 text-center">

                    <button
                        onClick={handleAnalyze}
                        disabled={loading}
                        className="bg-primary text-primary-foreground px-8 py-3 rounded-lg font-semibold hover:opacity-90 disabled:opacity-50"
                    >

                        {loading ? (

                            <span className="flex items-center gap-2">

                                <Loader2 className="animate-spin" size={18} />

                                Analyzing...

                            </span>

                        ) : (

                            "Analyze Song"

                        )}

                    </button>

                </div>

            </div>

            {result && (

                <div className="mt-10 rounded-2xl border border-border bg-card p-8">

                    <h2 className="text-3xl font-bold mb-6">
                        🎵 Analysis Result
                    </h2>

                    <div className="grid md:grid-cols-2 gap-6">

                        <div className="rounded-xl bg-secondary p-5">

                            <div className="text-sm text-muted-foreground">
                                Detected Sa
                            </div>

                            <div className="text-4xl font-bold mt-2">
                                {result.sa}
                            </div>

                        </div>

                        <div className="rounded-xl bg-secondary p-5">

                            <div className="text-sm text-muted-foreground">
                                Western Key
                            </div>

                            <div className="text-2xl font-bold mt-2">
                                {result.western_key}
                            </div>

                        </div>

                        <div className="rounded-xl bg-secondary p-5">

                            <div className="text-sm text-muted-foreground">
                                Tempo
                            </div>

                            <div className="text-2xl font-bold mt-2">
                                {result.tempo} BPM
                            </div>

                        </div>

                     <div className="rounded-xl bg-secondary p-5">

    <div className="text-sm text-muted-foreground">
        Duration
    </div>

    <div className="text-2xl font-bold mt-2">
        {Math.floor(result.duration / 60)}m {Math.round(result.duration % 60)}s
    </div>

</div>



                    </div>
					
<ScaleChanger
    file={file}
    result={result}
/>			


                    <div className="mt-8 flex justify-center">

                        <button
                            className="bg-primary text-primary-foreground px-8 py-3 rounded-lg font-semibold"
                            onClick={() => {

                                window.location.href =
									`/tanpura?scale=${encodeURIComponent(result.sa)}`;

                            }}
                        >

                            🎼 Start Tanpura

                        </button>

                    </div>

                </div>

            )}

        </div>

    );

}